import { useState } from 'react'

/** Per-section save lifecycle: pending flag plus inline error/success copy. */
export function useSectionSave(defaultError: string) {
  const [isSaving, setIsSaving] = useState(false)
  const [errorMessage, setErrorMessage] = useState<string | null>(null)
  const [successMessage, setSuccessMessage] = useState<string | null>(null)

  const run = async (work: () => Promise<void>, successCopy: string) => {
    setIsSaving(true)
    setErrorMessage(null)
    setSuccessMessage(null)
    try {
      await work()
      setSuccessMessage(successCopy)
    } catch (error) {
      setErrorMessage(
        error instanceof Error && error.message ? error.message : defaultError,
      )
    } finally {
      setIsSaving(false)
    }
  }

  return { isSaving, errorMessage, successMessage, run }
}
